import { createErrorReportingAsyncThunk } from "../../helpers";
import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";
import {
  sendContractorInvitationsReqT,
  ContractorInvitations,
  Contractors,
  SendContractorInvitation,
} from "./types";
import { getData } from "../../../axios";
import { contractorInvitationsT, contractorsT } from "dora-contracts";
import * as tPromise from "io-ts-promise";

const prefix = "data/contractors";

type State = {
  contractors: Contractors;
  pendingInvitations: ContractorInvitations;
};

const initialState: State = {
  contractors: [],
  pendingInvitations: [],
};

export const inviteContractor = createErrorReportingAsyncThunk(
  `${prefix}/invite-contractor}`,
  async (input: SendContractorInvitation, thunkAPI) => {
    await axios.post(
      "/api/contractors/invite",
      sendContractorInvitationsReqT.encode(input)
    );
  }
);

export const getContractors = createErrorReportingAsyncThunk(
  `${prefix}/get-contractors`,
  async () => {
    return axios
      .get("/api/contractors")
      .then(getData)
      .then(x => {
        console.log(x);
        return x;
      })
      .then(tPromise.decode(contractorsT));
  }
);

export const getContractorPendingInvitations = createErrorReportingAsyncThunk(
  `${prefix}/get-contractor-pending-invitations`,
  async () => {
    return axios
      .get("/api/contractors/invitations")
      .then(getData)
      .then(tPromise.decode(contractorInvitationsT));
  }
);

export const cancelContractorInvitation = createErrorReportingAsyncThunk(
  `${prefix}/cancel-contractor-invitation`,
  async (id: string) => {
    return axios.delete(`/api/contractors/invitations/${id}`);
  }
);

export const removeContractor = createErrorReportingAsyncThunk(
  `${prefix}/remove-contractor`,
  async (input: { id: string; notifyContractor: boolean }) => {
    const { id, notifyContractor } = input;
    return axios.delete(
      `/api/contractors/${id}?notifyContractor=${notifyContractor}`
    );
  }
);

export const updateContractorAssociatedClient = createErrorReportingAsyncThunk(
  `${prefix}/update-contractor-associated-client`,
  async (input: { id: string; clientId: string }) => {
    const { id, clientId } = input;
    return axios.put(`/api/contractors/${id}`, { clientId });
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractors.fulfilled, (state, action) => {
        state.contractors = action.payload;
      })
      .addCase(removeContractor.fulfilled, (state, action) => {
        state.contractors = state.contractors.filter(
          (c) => c.id !== action.meta.arg.id
        );
      })
      .addCase(getContractorPendingInvitations.fulfilled, (state, action) => {
        state.pendingInvitations = action.payload;
      })
      .addCase(cancelContractorInvitation.fulfilled, (state, action) => {
        state.pendingInvitations = state.pendingInvitations.filter(
          (i) => i.id !== action.meta.arg
        );
      })
      .addCase(updateContractorAssociatedClient.fulfilled, (state, action) => {
        const id = action.meta.arg.id;
        const clientId = action.meta.arg.clientId;
        const c = state.contractors.find((x) => x.id === id);
        if (c) c.clientId = clientId;
      });
  },
});

export default slice.reducer;
